import { ChangeDetectionStrategy,Component, Optional ,Input,EventEmitter,Output,ChangeDetectorRef} from "@angular/core";
import { InvoiceAttachmentsDTO } from "@models/InvoiceAttachmentsDTO";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DashboardService } from '../service/dashboardservice';
import {saveAs as importedSaveAs} from "file-saver"; 
import { InvoiceViewModel } from "@models/InvoiceViewModel";

@Component({
    selector: "app-modal",
    styleUrls: ['../starter.component.scss'],
    templateUrl: "./downloadFile.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadFileModalComponent {
  @Output() eventEmitter: EventEmitter<any> = new EventEmitter();
  @Input() invoiceid;
    private _messageBox: any;
    constructor( @Optional() private readonly activeModal: NgbActiveModal,private _dashboardService: DashboardService, private _cd: ChangeDetectorRef) {
  }
  public invoiceId:any;
  public invs:Array<InvoiceViewModel> = [];
  public invoiceAttachment:any;
  public invoiceAttachmentWebForm:any;
  file:any;


  ngOnInit() {
    this._dashboardService.getFileAttachment(this.invoiceId).subscribe((data:Array<InvoiceAttachmentsDTO>) =>{
        console.log(data);
        this.invoiceAttachmentWebForm = data;
        if(this.invoiceAttachmentWebForm.length > 0){
            this.invoiceAttachmentWebForm.forEach(element => {
                this.invoiceAttachment = element.RawFileName;
                this.file =  this.invoiceAttachment ;
                console.log(this.invoiceAttachment);
                this._cd.detectChanges();
            });
        }else{
          this._messageBox.open("No Attachment!");
        }
      });
  }

  public downloadAttachment(attachment){
    this._dashboardService.getWebResAttachment(attachment.EncPath,"y",attachment.InvoiceId).subscribe((data) =>{
      importedSaveAs(data, attachment.RawFileName);
    });
  }

  

  public downloadModal(invoiceId) {
    var scope = this;
    this._dashboardService.getFileAttachment(invoiceId).subscribe((data:Array<InvoiceAttachmentsDTO>) => {
      scope.invoiceAttachmentWebForm = data;
      if(scope.invoiceAttachmentWebForm.length > 0){
      }else{
        this._messageBox.open("No Attachment!");
      }
    });
  }

  public dismiss(): void {
    if (this.activeModal)
      this.activeModal.dismiss();
  } 
}
